import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import CONFIG from "./config";
import { useTranslation } from 'react-i18next';

// Import your sample pages:
import SamplePublicPage from "./samplePublicPage";
import SampleDashboard from "./SampleDashboard";

const LoginPage = () => {
  const { t } = useTranslation(['login', 'common']);
  const [redirectError, setRedirectError] = useState("");
      const [redirectSuccess, setRedirectSuccess] = useState("");
       // Handle redirect uccess or failure messages
      useEffect(() => {
              const queryParams = new URLSearchParams(window.location.search);
              const errorParam = queryParams.get("error");
              const successParam = queryParams.get("success");
            
              if (errorParam) {
                setRedirectError(errorParam);
              }
              if (successParam) {
                setRedirectSuccess(successParam);
              }
  
              // Remove the query parameters from the URL without reloading the page
              const newUrl = window.location.pathname;
              window.history.replaceState(null, "", newUrl);
            }, []);   
  const [formData, setFormData] = useState({ email: "", password: "", stayLoggedIn: false });
  const [registerData, setRegisterData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    referralCode: "",
  });
  const [forgotEmail, setForgotEmail] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showRegisterFields, setShowRegisterFields] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [showMoreBusinessLeads, setShowMoreBusinessLeads] = useState(false);
  const [showTestimonials, setShowTestimonials] = useState(false);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [showMoreExperienceIt, setShowMoreExperienceIt] = useState(false);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1120);

  // Toggle the entire login/forgot-password/register block
  const [showLoginForms, setShowLoginForms] = useState(false);

  // Tabs for the right side
  const [activeTab, setActiveTab] = useState("public");

  const businessLeadsRef = useRef(null);
  const businessLeadsRef2 = useRef(null);
  const detailsRef = useRef(null);
  const detailsRef2 = useRef(null);
  const experienceItRef = useRef(null);
  const experienceItRef2 = useRef(null);
  const testimonialsRef = useRef(null);
  const testimonialsRef2 = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
        if (showMoreBusinessLeads && businessLeadsRef.current && businessLeadsRef2.current && !businessLeadsRef.current.contains(event.target) && !businessLeadsRef2.current.contains(event.target)) {
            setShowMoreBusinessLeads(false);
        }
        if (showMoreDetails && detailsRef.current && detailsRef2.current && !detailsRef.current.contains(event.target) && !detailsRef2.current.contains(event.target)) {
            setShowMoreDetails(false);
        }
        if (showMoreExperienceIt && experienceItRef2.current && !experienceItRef2.current.contains(event.target)) {
            setShowMoreExperienceIt(false);
        }
        if (showTestimonials && testimonialsRef.current && testimonialsRef2.current && !testimonialsRef.current.contains(event.target) && !testimonialsRef2.current.contains(event.target)) {
            setShowTestimonials(false);
        }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, [showMoreBusinessLeads, showMoreDetails, showMoreExperienceIt, showTestimonials]);

  useEffect(() => {
    const checkAuth = async () => {
        try {
            const response = await axios.get(`${CONFIG.BACKEND_URL}/api/check-auth`, {
                withCredentials: true, // Ensures cookies are sent with the request
            });

            if (response.data.authenticated) {
                navigate("/dashboard"); // Redirect if already authenticated
            }
        } catch (err) {
            console.log("User is not authenticated.");
        }
    };

    checkAuth();
}, []);
  
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + CONFIG.siteKey;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Handle verification success or failure messages
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("verified") === "true") {
      setMessage(t('login:registrationSuccessful'));
    } else if (params.get("error") === "invalid_token") {
      setError(t('login:verificationFailed'));
    }
    // Remove the query parameters from the URL without reloading the page
    const newUrl = window.location.pathname;
    window.history.replaceState(null, "", newUrl);
  }, [location.search]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
        const token = await window.grecaptcha.enterprise.execute(CONFIG.siteKey, { action: "submit" });

        await axios.post(`${CONFIG.BACKEND_URL}/api/login`, {
            ...formData,
            recaptchaToken: token,
            action: "submit",
            stayLoggedIn: formData.stayLoggedIn,
        }, {
            withCredentials: true, // Ensures cookies are sent with request
        });

        navigate("/dashboard"); // Redirect after successful login
    } catch (err) {
        setError(err.response?.data?.error || t('login:loginFailed'));
    }
};

  const handleRegister = async (e) => {
    setMessage("");
    setError("");
    e.preventDefault();
    if (registerData.email === "") {
      setError(t('login:enterEmail'));
      return;
    }
    if (registerData.password === "") {
      setError(t('login:enterPassword'));
      return;
    }
    if (registerData.confirmPassword === "") {
      setError(t('login:confirmPasswordRequired'));
      return;
    }
    if (registerData.password !== registerData.confirmPassword) {
      setError(t('login:passwordsDoNotMatch'));
      return;
    }
    try {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const requestData = {
        email: registerData.email,
        password: registerData.password,
        timezone: userTimezone,
        referralCode: registerData.referralCode?.toLowerCase(),
      };

      const token = await window.grecaptcha.enterprise.execute(CONFIG.siteKey, { action: 'submit' });
            
      const response = await axios.post(`${CONFIG.BACKEND_URL}/api/pre-register`, {
                  ...requestData,
                  recaptchaToken: token,
                  action: "submit",
                     });
      setMessage(response.data.message || t('login:verificationEmailSent'));      
      setShowRegisterFields(false);
    } catch (err) {
      if (err.response && err.response.status === 400) {
        const errorMessage = err.response.data.error || t('login:invalidRequest');
        setError(errorMessage);
      } else {
        setError(t('login:registrationFailed'));
      }
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      setError(t('login:enterEmail'));
      return;
    }
    try {
      const response = await axios.post(`${CONFIG.BACKEND_URL}/api/forgot-password`, {
        email: forgotEmail,
      });
      setMessage(response.data.message);
      setError("");
    } catch (err) {
      setError(err.response?.data?.error || t('login:passwordResetFailed'));
    }
  };

  useEffect(() => {
    const handleResize = () => {
        setIsWideScreen(window.innerWidth > 1120);
    };

    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
        window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {/* Inline CSS via <style> for media queries */}
      <style>{`
        .page-wrapper {
          width: auto;
          display: flex;
          flex-direction: row;
          height: auto;
          font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Segoe UI', sans-serif;
          background-color: var(--apple-gray-1);
        }
        
        .left-panel {
          width: 50%;
          height: 100%;
          padding: var(--spacing-2xl);
          padding-top: var(--spacing-xl);
          padding-left: 10%;
          padding-right: 10%;
          overflow-y: auto;
          margin-bottom: var(--spacing-xl);
          background-color: var(--apple-white);
        }
        
        .right-panel {
          width: 70%;
          height: 100%;
          background-color: var(--apple-gray-6);
          padding: 0px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
        }
        .footer {
          margin-top: var(--spacing-3xl);
          padding: var(--spacing-md) 0;
          background-color: var(--apple-gray-2);
          text-align: center;
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: var(--font-size-xs);
          height: auto;
          color: var(--apple-gray-5);
        }

        /* On smaller screens, stack top-to-bottom */
        @media (max-width: 1120px) {
          .page-wrapper {
            flex-direction: column;
          }
          .left-panel {
            width: auto;
          }
          .right-panel {
            width: 100% !important;
          }
        }
        .tabs-header {
          display: flex;
          margin-bottom: 0px;
        }
        .tab-button {
          flex: 1;
          margin-right: 0px;
          padding: var(--spacing-md);
          cursor: pointer;
          color: var(--apple-white);
          border: none;
          border-radius: 0px;
          background-color: var(--apple-gray-4);
          font-weight: 500;
          font-size: var(--font-size-base);
          transition: all var(--transition-fast);
          letter-spacing: -0.022em;
        }
        .tab-button:hover {
          background-color: var(--apple-gray-5);
        }
        .tab-button.active {
          background-color: var(--apple-gray-6);
        }
        .tab-content {
          flex: 1;
          background-color: var(--apple-white);
          padding: 0px;
          border-radius: 0px;
          overflow-y: auto;
        }
        .top-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: var(--spacing-xl) 0 0 0;
          line-height: 1.6;
        }
        .logo {
          font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif;
          font-weight: 600;
          font-size: var(--font-size-xl);
          color: var(--apple-gray-6);
          margin: 0;
          letter-spacing: -0.02em;
        }
        .login-toggle-btn {
          padding: var(--spacing-sm) var(--spacing-lg);
          border: none;
          border-radius: var(--radius-lg);
          background-color: var(--apple-blue);
          color: var(--apple-white);
          cursor: pointer;
          font-size: var(--font-size-sm);
          font-weight: 400;
          letter-spacing: -0.022em;
          transition: all var(--transition-base);
          box-shadow: var(--shadow-sm);
        }
        .login-toggle-btn:hover {
          background-color: var(--apple-blue-hover);
          transform: translateY(-1px);
          box-shadow: var(--shadow-md);
        }
        .top-main-text {
          color: var(--apple-blue);
          font-weight: 600;
          margin-top: var(--spacing-3xl);
          margin-bottom: var(--spacing-2xl);
          font-size: var(--font-size-base);
          letter-spacing: -0.02em;
        }
        .main-text {
          color: var(--apple-gray-6);
          font-weight: 600;
          margin-top: var(--spacing-2xl);
          margin-bottom: var(--spacing-2xl);
          font-size: var(--font-size-sm);
          letter-spacing: -0.02em;
        }
        .mid-main-text {
          color: var(--apple-gray-6);
          font-weight: 600;
          margin-top: var(--spacing-2xl);
          margin-bottom: var(--spacing-2xl);
          font-size: var(--font-size-sm);
          letter-spacing: -0.02em;
        }
        .sub-main-text {
          color: var(--apple-gray-6);
          font-weight: 600;
          margin-top: var(--spacing-2xl);
          font-size: var(--font-size-sm);
          letter-spacing: -0.02em;
        }
        .subtitle {
          font-size: var(--font-size-base);
          color: var(--apple-gray-5);
          margin-bottom: var(--spacing-xl);
          line-height: 1.6;
        }
        .input-box {
          width: 100%;
          padding: var(--spacing-md);
          border-radius: var(--radius-md);
          border: 1px solid var(--apple-gray-3);
          font-size: var(--font-size-base);
          margin: var(--spacing-md) 0;
          display: block;
          background-color: var(--apple-white);
          color: var(--apple-gray-6);
          transition: all var(--transition-fast);
          box-sizing: border-box;
        }
        .input-box:focus {
          outline: none;
          border-color: var(--apple-blue);
          box-shadow: 0 0 0 4px rgba(0, 113, 227, 0.1);
        }
        .button-row {
          width: 100%;
          text-align: left;
        }
        .common-button {
          padding: var(--spacing-md) var(--spacing-xl);
          background-color: var(--apple-blue);
          color: var(--apple-white);
          border: none;
          border-radius: var(--radius-lg);
          cursor: pointer;
          transition: all var(--transition-base);
          margin-top: var(--spacing-md);
          font-size: var(--font-size-base);
          font-weight: 400;
          letter-spacing: -0.022em;
          box-shadow: var(--shadow-sm);
        }
        .common-button:hover {
          background-color: var(--apple-blue-hover);
          transform: translateY(-1px);
          box-shadow: var(--shadow-md);
        }
        .privacy-terms-box {
          padding: var(--spacing-lg);
          border: 1px solid var(--apple-gray-2);
          border-radius: var(--radius-lg);
          background-color: var(--apple-gray-1);
          max-height: 400px;
          overflow-y: auto;
          box-shadow: var(--shadow-sm);
        }
        .details-section {
          position: absolute;
          z-index: 1000;
          left: 20%;
          margin-top: -30px;
          max-width: 260px;
          padding: var(--spacing-sm) var(--spacing-xl) var(--spacing-md) var(--spacing-xl);
          border-radius: var(--radius-lg);
          background-color: var(--apple-white);
          margin-bottom: var(--spacing-xl);
          font-size: var(--font-size-xs);
          text-align: left;
          font-weight: 500;
          box-shadow: var(--shadow-md);
          border: 1px solid var(--apple-gray-2);
      }
      `}</style>

      <div className="page-wrapper">
        {/* Left side */}
        <div className="left-panel">
          <div className="top-section">
            <p className="logo">
              <a href={`${CONFIG.FRONTEND_URL}`} style={{ textDecoration: "none", color: "inherit" }}>
                Rili Day
              </a>
            </p>

            {/* Toggle button: show/hide forms */}
            <button
              className="login-toggle-btn"
              onClick={() => setShowLoginForms(!showLoginForms)}
            >
              {showLoginForms ? t('common:close') : t('login:login') + " or " + t('login:register')}
            </button>
          </div>

          {error && <p style={{ color: "red" }}>{error}</p>}
          {message && <p style={{ color: "green" }}>{message}</p>}
          {redirectError && <p style={{ color: "red" }}>{redirectError}</p>}
          {redirectSuccess && <p style={{ color: "green" }}>{redirectSuccess}</p>}

          {/* Conditionally show the entire login/forgot-password/register block */}
          {showLoginForms && (
            <>
              <h1 className="subtitle">{t('login:login')}</h1>
              

              <form onSubmit={handleLogin}>
                <input
                  className="input-box"
                  type="email"
                  placeholder={t('common:email')}
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
                <input
                  className="input-box"
                  type="password"
                  placeholder={t('common:password')}
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                />
                <div>
                  <input
                    type="checkbox"
                    id="stayLoggedIn"
                    checked={formData.stayLoggedIn}
                    onChange={(e) => setFormData({ ...formData, stayLoggedIn: e.target.checked })}
                  />
                  <label htmlFor="stayLoggedIn">{t('login:stayLoggedIn')}</label>
                </div>
                <div className="button-row">
                  <button type="submit" className="common-button" style={{ backgroundColor: "#28a745" }}>
                    {t('login:login')}
                  </button>
                </div>
              </form>

              <button onClick={() => setShowForgotPassword(!showForgotPassword)} className="common-button">
                {t('login:forgotPassword')}
              </button>

              {showForgotPassword && (
                <div>
                  <input
                    type="email"
                    placeholder={t('login:enterEmail')}
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    className="input-box"
                  />
                  <div className="button-row">
                    <button onClick={handleForgotPassword} className="common-button">
                      {t('login:resetPassword')}
                    </button>
                  </div>
                </div>
              )}

              <div className="button-row">
                <button onClick={() => setShowRegisterFields(!showRegisterFields)} className="common-button">
                  {t('login:register')}
                </button>
              </div>

              {showRegisterFields && (
                <form onSubmit={handleRegister} style={{ marginTop: "10px" }}>
                  <input
                    className="input-box"
                    type="email"
                    placeholder={t('common:email')}
                    value={registerData.email}
                    onChange={(e) => setRegisterData({ ...registerData, email: e.target.value })}
                  />
                  <input
                    className="input-box"
                    type="password"
                    placeholder={t('common:password')}
                    value={registerData.password}
                    onChange={(e) => setRegisterData({ ...registerData, password: e.target.value })}
                  />
                  <input
                    className="input-box"
                    type="password"
                    placeholder={t('login:confirmPassword')}
                    value={registerData.confirmPassword}
                    onChange={(e) => setRegisterData({ ...registerData, confirmPassword: e.target.value })}
                  />
                  <input
                    className="input-box"
                    type="text"
                    placeholder={t('login:referralCode')}
                    value={registerData.referralCode}
                    onChange={(e) => setRegisterData({ ...registerData, referralCode: e.target.value })}
                  />
                  <div style={{ margin: "10px 0" }}>
                    <input type="checkbox" required />
                    <span> {t('login:agreeToTerms')} 
                                {" "}
                                <a href={`${CONFIG.FRONTEND_URL}/privacy`} target="_blank" rel="noopener noreferrer">
                                    {t('common:privacyPolicy')}
                                </a>
                                {" "}|{" "}
                                <a href={`${CONFIG.FRONTEND_URL}/terms`} target="_blank" rel="noopener noreferrer">
                                    {t('common:termsOfService')}
                                </a>.
                            </span>
                  </div>
                  <button type="submit" className="common-button">
                    {t('login:register')}
                  </button>
                </form>
              )}
            </>
          )}
          <div className="top-main-text">
            <p>{t('login:announcement')}</p>
            <h1>
              <br />
              <br />
              
            </h1>
          </div>
          
          <div className="main-text">
            <h1>
              {t('login:createBusinessPage')}
              <br />
              <a
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => setShowMoreDetails(!showMoreDetails)}
                ref={detailsRef2}
              >
                {t('login:moreDetails')}
              </a>
            </h1>
            {showMoreDetails && 
            <div ref={detailsRef}>
            <p>
              {t('login:platformDescription')}
            </p>
            <p 
              style={{fontSize: '14px'}}
              dangerouslySetInnerHTML={{ __html: t('login:platformFeatures') }}
            />
            </div>}
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>

          

          <div className="mid-main-text">
            <h1>
              {t('login:businessWithCalendar')}
              <br />
              <a
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => setShowMoreBusinessLeads(!showMoreBusinessLeads)}
                  ref={businessLeadsRef}
              >
                  {t('login:businessLeads')}
              </a>
            </h1>
            {showMoreBusinessLeads && <div ref={businessLeadsRef2}>
              {t('login:businessLeadsDescription')}
            </div>}
          </div>

          <div className="mid-main-text">
            <h1>
              <a
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => setShowTestimonials(!showTestimonials)}
                  ref={testimonialsRef2}
              >
                {t('login:howOthersUse')} 
              </a>
              {" "}{t('common:appName')}
            </h1>
            {showTestimonials && <div ref={testimonialsRef}>
              {t('login:testimonial1')}
              {" "}<a href="https://www.rili.day/tangoit" target="_blank" rel="noopener noreferrer">
                rili.day/tangoit
              </a>
              <br />
              {t('login:testimonial2')}
              {" "}<a href="https://www.rili.day/ledgurulighting" target="_blank" rel="noopener noreferrer">
                rili.day/ledgurulighting
              </a>
              <br />
              {t('login:testimonial3')}
              {" "}<a href="https://www.rili.day/sphereofall" target="_blank" rel="noopener noreferrer">
                rili.day/sphereofall
              </a>
              
            </div>}
          </div>

          <div className="sub-main-text">
            <h1>
              <a
                style={{ cursor: "pointer", textDecoration: "underline" }}
                ref={experienceItRef2}
                onClick={() => {setTimeout(() => {
                  if (experienceItRef.current && !isWideScreen) {
                      experienceItRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                  setShowMoreExperienceIt(!showMoreExperienceIt);
              }, 100);}}
              >
                {t('login:experienceIt')}
              </a>
            </h1>
            {isWideScreen && showMoreExperienceIt && (
                <p>
                    {t('login:checkSamplePages')}
                </p>
            )}
          </div>

          
        </div>

        

        {/* Right side: Tabbed sample pages */}
        <div className="right-panel" ref={experienceItRef}>
          <div className="tabs-header">
            <button
              className={`tab-button ${activeTab === "public" ? "active" : ""}`}
              onClick={() => setActiveTab("public")}
            >
              {t('login:samplePublicPage')}
            </button>

            <button
              className={`tab-button ${activeTab === "dashboard" ? "active" : ""}`}
              onClick={() => setActiveTab("dashboard")}
            >
              {t('login:sampleDashboard')}
            </button>
          </div>

          <div className="tab-content">
            {activeTab === "dashboard" && <SampleDashboard />}
            {activeTab === "public" && <SamplePublicPage />}
          </div>
        </div>
      </div>
      <div className="footer">
          <p>
            <a href={`${CONFIG.FRONTEND_URL}/privacy`}>{t('common:privacyPolicy')}</a>
            {" "}|{" "}
            <a href={`${CONFIG.FRONTEND_URL}/terms`}>{t('common:termsOfService')}</a>
          </p>
      </div>
    </>
  );
};

export default LoginPage;
